export default __webpack_public_path__ + "static/media/VisibilityOn.186033de.svg";